const SET_CACHE = (state, data) => {
  state.cache = data
}

const SET_PURGING = (state, key) => {
  state.purging = key
}

const SET_PROGRESS = (state, payload) => {
  state.progress.length = state.progress.length + payload.length
  state.progress.total = payload.total
}

const RESET_PROGRESS = (state) => {
  state.progress.length = null
  state.progress.total = null
}

const REMOVE = (state, key) => {
  const idx = state.cache.findIndex(x => x === key)

  state.cache.splice(idx, 1)
}

const SET_STREAM = (state, payload) => {
  state.streams.push(payload)
}

const CLOSE_STREAM = (state, id) => {
  console.log(`Received kill signal, closing stream with id ${id}`)

  const stream = state.streams.find(x => x.id === id)

  if (stream) {
    stream.stream.close()
    stream.terminated = true

    console.log(`Stream ${id} closed`)
  } else {
    console.error(`Could not find stream with id ${id}`)
  }
}

const SET_RESPONSE = (state, payload) => {
  const idx = state.streams.findIndex(x => x.id === payload.id)

  if (idx !== -1) {
    state.streams[idx].timestamp = payload.timestamp
    state.streams[idx].response = payload.response[state.streams[idx].property]
  } else {
    console.error(`Could not find stream with id ${payload.id}`)
  }
}

const SET_CACHE_PARAM = (state, payload) => {
  const stream = state.streams.find(x => x.id === payload.id)

  if (stream) {
    stream[payload.key] = payload.value
  }
}

const KILL_ALL_EVENT_STREAMS = (state) => {
  state.streams.forEach(stream => {
    stream.stream.close()
    stream.terminated = true
  })
}

export default {
  REMOVE,
  SET_CACHE,
  SET_STREAM,
  SET_PURGING,
  SET_PROGRESS,
  CLOSE_STREAM,
  SET_RESPONSE,
  RESET_PROGRESS,
  SET_CACHE_PARAM,
  KILL_ALL_EVENT_STREAMS
}
